/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment -- Disable all rules issued from linter */
const getTextLoop = (element: any) => {
  const texts: any[] = [];
  const childNodes = [...element.childNodes];
  for (const node of childNodes) {
    if (node.nodeType === 3) {
      texts.push(node.textContent.trim());
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Unknown data type
      texts.push(...getTextLoop(node));
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Unknown data type
  return texts;
};

const innerText = (element: any) => {
  return getTextLoop(element).join(' ');
};

const serialize = (editor: any) => {
  const html = editor.getData();

  const div = document.createElement('div');
  div.innerHTML = html;
  const text = innerText(div);

  return {
    html,
    text,
  };
};

export default serialize;
/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment -- Disable all rules issued from linter */
